import PropTypes from "prop-types";
import { isValidUrl } from "../../../helpers/global";
import skuPlaceholder from "../../../assets/images/skuPlaceholder.png";

const ImagePlaceholder = (props) => {
  const { className, src, alt, ...rest } = props;

  return (
    <img
      className={className}
      src={isValidUrl(src) ? src : skuPlaceholder}
      alt={alt}
      {...rest}
    />
  );
};

export default ImagePlaceholder;

ImagePlaceholder.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
};
